import React, { useEffect } from 'react';
import { sortBy, mapValues } from 'lodash';

import { canUpdateCartSettings, } from '../../shared/abilities';
import firebase from '../../firebase';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionSubscriptionInTenant from '../hooks/useCollectionSubscriptionInTenant';
import useUserTags from '../hooks/useUserTags';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import EditButton from '../EditButton';
import ModalButton from '../ModalButton';
import AddInTenantButton from '../AddInTenantButton';
import DeleteButton from '../DeleteButton';
import RichTextContent from '../RichTextContent';
import { cartSettingsFields } from '../../shared/models/setting';
import { fields as deliveryUnavailableDateFields } from '../../shared/models/deliveryUnavailableDate';
import { fieldDisplayValue } from '../../shared/util';

const db = firebase.firestore();
const { entries } = Object;

const deliveryUnavailableDatesRef = db.collection('deliveryUnavailableDates');

export default AdminPage(function AdminCartSettings (props) {
  const { tenant, user, match: { params: { tenantPath } } } = props;
  const cartSettingsRef = db.collection('settings').doc([tenantPath, 'cart'].join('__'));
  const cartSettings = useDocumentSubscription(cartSettingsRef);
  const userTags = useUserTags();
  useEffect(() => {
    if(cartSettings === null) {
      cartSettingsRef.set({ tenantId: tenant.id, ...mapValues(cartSettingsFields({ userTags, }), _ => '') });
    }
  }, [cartSettings])

  return cartSettings != null && (
    <div>
      <div className="admin-cart-settings container py-5 position-relative">
        <div className="bg-white p-4">
          <div className="d-flex justify-content-end mb-3 gap-1">
            <ModalButton
              title="配送指定不可日管理"
              content={() => <DeliveryUnavailableDatesManagement tenant={tenant} user={user} />}
              modalProps={{ style: { minWidth: 800 } }}
            >
              配送指定不可日
            </ModalButton>
            <EditButton color="primary" itemRef={cartSettingsRef} FormModal={ModelFormModal} formProps={{ title: 'カート設定', fields: cartSettingsFields({ userTags }), }} disabled={!canUpdateCartSettings(user)} />
          </div>
          <table className="table table-bordered align-middle thead-light">
            <tbody>
              {
                entries(cartSettingsFields({ userTags })).map(([fieldName, fieldSettings]) => {
                  const { label } = fieldSettings;
                  return (
                    <tr key={fieldName}>
                      <th>
                        {label}
                      </th>
                      <td>
                        {
                          fieldSettings.type === 'richText' ? (
                            <RichTextContent html={cartSettings[fieldName] || ''} />
                          ) : (
                            <div style={{ whiteSpace: 'pre-line', }}>
                              {fieldDisplayValue(cartSettings[fieldName], fieldSettings)}
                            </div>
                          )
                        }
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

function DeliveryUnavailableDatesManagement(props) {
  const { tenant, user } = props;
  const deliveryUnavailableDates = sortBy(useCollectionSubscriptionInTenant(deliveryUnavailableDatesRef), _ => _.startDate.toDate());

  return (
    <div>
      <div className="d-flex justify-content-end mb-3">
        <AddInTenantButton
          itemRef={deliveryUnavailableDatesRef.doc()}
          FormModal={ModelFormModal}
          formProps={{ title: '配送指定不可日追加', fields: deliveryUnavailableDateFields() }}
          disabled={!canUpdateCartSettings(user)}
        />
      </div>
      <table className="table">
        <thead className="thead-light text-center">
          <tr>
            <th>開始日</th>
            <th>終了日</th>
            <th>説明</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {deliveryUnavailableDates.map((date) => {
            const { id, ref, description, startDate, endDate } = date;
            return (
              <tr key={id}>
                <td>{startDate?.toDate().toLocaleDateString()}</td>
                <td>{endDate?.toDate().toLocaleDateString()}</td>
                <td>{description}</td>
                <td className="text-nowrap text-right">
                  <EditButton
                    itemRef={ref}
                    className="ml-1"
                    FormModal={ModelFormModal}
                    formProps={{ title: '配送指定不可日編集', fields: deliveryUnavailableDateFields() }}
                    disabled={!canUpdateCartSettings(user)}
                  />
                  <DeleteButton itemRef={ref} className="ml-1" disabled={!canUpdateCartSettings(user)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
